





























































































































































































































import Hls from 'hls.js';
import Component, { mixins } from 'vue-class-component';
import PlayerControls from '@/app/components/PlayerControls.vue';
import SlidePlayerControls from '@/app/components/SlidePlayerControls.vue';
import PlayerControllerMixin from '@/app/player/mixins/PlayerControllerMixin.ts';
import TButton from '@/lib/form/button/Button.vue';

import logger from '../logger';

declare global {
  interface Navigator {
    mediaSession: any;
  }
  interface HTMLVideoElement {
    requestPictureInPicture(): Promise<any>;
  }
}

@Component({
  name: 'video-player',
  props: ['video', 'embed'],
  components: {
    PlayerControls,
    SlidePlayerControls,
    TButton
  }
})
export default class VideoPlayer extends mixins(PlayerControllerMixin) {
  private showVideoControls = false;
  private source!: any;
  private canShowSlideMode;

  mounted() {
    this.renderVideo();
    this.setCanvasProperties();
    window.addEventListener('resize', this.resetCanvasProperties);
    this.attachPipEventListeners();
  }

  get canShowControls() {
    return (
      this.showVideoControls &&
      !this.showPlayButton &&
      !this.$isMobile &&
      !this.showAllRelativeCtaLinks
    );
  }

  attachPipEventListeners() {
    if ('mediaSession' in navigator) {
      navigator.mediaSession.setActionHandler('play', event => {
        this.togglePlay();
      });
      navigator.mediaSession.setActionHandler('pause', event => {
        this.togglePlay();
      });
      navigator.mediaSession.setActionHandler('previoustrack', () => {
        this.prev();
      });
      navigator.mediaSession.setActionHandler('nexttrack', () => {
        this.next();
      });
    }
    const video = this.$refs.videoElement as HTMLVideoElement;
  }

  renderVideo() {
    this.$nextTick(() => {
      const videoElement = this.$refs.videoElement as HTMLVideoElement;
      if (!videoElement) {
        logger.warn('transition affecting render');
        window.setTimeout(() => {
          this.renderVideo();
        }, 250);
        return;
      }
      if (Hls.isSupported() && this.source.indexOf('.mp4') == -1) {
        this.hls = new Hls();
        this.hls.config.abrMaxWithRealBitrate = true;
        this.hls.config['renderTextTracksNatively'] = false;
        this.hls.loadSource(this.source!);
        this.hls.attachMedia(videoElement);
        this.hls.on(Hls.Events.MANIFEST_LOADED, () => {
          if (this.hls.subtitleTracks.length > 0) {
            this.hls.subtitleTrack = 0;
          }
        });
        this.hls.on('hlsCuesParsed', (event, data) => {
          const subtitleTracks: any[] = [];
          if (!this.$isEmpty(data) && !this.$isEmpty(data.cues)) {
            data.cues.forEach(cue => {
              subtitleTracks.push({
                id: cue.id,
                startTime: cue.startTime,
                endTime: cue.endTime,
                text: cue.text
              });
            });
          }
          if (!this.$isEmpty(this.hlsSubtitleTracks[data.track])) {
            this.hlsSubtitleTracks[data.track] = [
              ...new Set([
                ...this.hlsSubtitleTracks[data.track],
                ...subtitleTracks
              ])
            ];
          } else {
            this.hlsSubtitleTracks[data.track] = subtitleTracks;
          }
        });
        this.hls.on('hlsSubtitleTrackSwitch', (event, data) => {
          this.subtitleIndex = data.id;
        });
      } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
        videoElement.src = this.source!;
      } else if (this.source.indexOf('.mp4') > -1) {
        videoElement.src = this.source!;
      }
    });
  }

  videoOnLoaded(event) {
    if (!event.target) {
      return;
    }
    if (!event.target.canPlayType) {
      logger.error('cannot play video');
    }
    this.ratio = event.target.videoWidth / event.target.videoHeight;
    this.setCanvasProperties();
    // video controls
    this.showVideoControls = true;
    this.duration = event.target.duration;
    this.currentTime = event.target.currentTime;
    this.volume = event.target.volume;
    this.muted = event.target.muted;
    this.$emit('video_loaded');
  }

  destroyed() {
    window.removeEventListener('resize', this.resetCanvasProperties);
    document.removeEventListener('fullscreenchange', this.fullscreenchange);
    document.removeEventListener(
      'webkitfullscreenchange',
      this.fullscreenchange
    );
    this.clearAnimation();
  }
}
